/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseSchriftrolle } from './DatabaseSchriftrolle';
import {
    DatabaseSchriftrolleFromJSON,
    DatabaseSchriftrolleFromJSONTyped,
    DatabaseSchriftrolleToJSON,
} from './DatabaseSchriftrolle';

/**
 * DREI SCHRIFTROLLEN statt einunddreissig Einzeleigenschaften (Vorgabe des Betreibers 31.08.2026: "nur drei Schriftarten und dahinter meinetwegen klein, gross, mittel schreiben. Daraus koennten wir dann alles ableiten").
 * Vorher trug jedes Element seine eigene Schriftart und -groesse -- Ueberschrift, Label, Anzeige, Bearbeitung, Gruppierung, Listen-Gruppe, Kopf, Fuss. Einunddreissig Werte, die nur zufaellig zueinander passten, und bei jeder Aenderung musste man sie einzeln nachziehen.
 * JEDE ROLLE HAT IHRE EIGENEN DREI STUFEN, und das ist der Kern der Sache (Betreiber: "Bei Ueberschriften ist Mittel aber groesser als bei Inhalten"). Eine gemeinsame Groessenskala haette Ueberschrift und Fliesstext auf dieselbe Pixelzahl gezwungen. So bleibt "mittel" ueberall die Vorgabe und heisst in jeder Rolle etwas anderes.
 * WELCHES ELEMENT WELCHE ROLLE TRAEGT, steht NICHT hier, sondern fest in der Anwendung -- es ist eine Zuordnung, keine Einstellung. Sonst waeren wir bei den einunddreissig Einzelwerten zurueck.
 * LEER HEISST "ERBT": Ein leeres Feld nimmt den Wert des Farbschemas bzw. die bisherige Vorgabe. Und die alten Einzeleigenschaften (`detailsHeadingFontFamily` und die uebrigen) SCHLAGEN diese Rollen, solange sie gesetzt sind -- eine bestehende Datenbank sieht nach dem Umbau exakt aus wie vorher.
 * @export
 * @interface DatabaseSchriftrollen
 */
export interface DatabaseSchriftrollen {
    /**
     * 
     * @type {DatabaseSchriftrolle}
     * @memberof DatabaseSchriftrollen
     */
    ueberschriften?: DatabaseSchriftrolle;
    /**
     * 
     * @type {DatabaseSchriftrolle}
     * @memberof DatabaseSchriftrollen
     */
    inhalte?: DatabaseSchriftrolle;
    /**
     * 
     * @type {DatabaseSchriftrolle}
     * @memberof DatabaseSchriftrollen
     */
    akzente?: DatabaseSchriftrolle;
}

/**
 * Check if a given object implements the DatabaseSchriftrollen interface.
 */
export function instanceOfDatabaseSchriftrollen(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSchriftrollenFromJSON(json: any): DatabaseSchriftrollen {
    return DatabaseSchriftrollenFromJSONTyped(json, false);
}

export function DatabaseSchriftrollenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSchriftrollen {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ueberschriften': !exists(json, 'ueberschriften') ? undefined : DatabaseSchriftrolleFromJSON(json['ueberschriften']),
        'inhalte': !exists(json, 'inhalte') ? undefined : DatabaseSchriftrolleFromJSON(json['inhalte']),
        'akzente': !exists(json, 'akzente') ? undefined : DatabaseSchriftrolleFromJSON(json['akzente']),
    };
}

export function DatabaseSchriftrollenToJSON(value?: DatabaseSchriftrollen | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ueberschriften': DatabaseSchriftrolleToJSON(value.ueberschriften),
        'inhalte': DatabaseSchriftrolleToJSON(value.inhalte),
        'akzente': DatabaseSchriftrolleToJSON(value.akzente),
    };
}

